<template src="./Banner.component.html"></template>
<style type="text/css" src="./Banner.component.css"></style>

<script>
export default {
  name: 'Banner',
  data () {
    return {}
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Banner/Banner.component.vue